import logoHeaderFondo from '@/assets/images/header/logo-header-mobile-fondo.svg'
import logoHeader from '@/assets/images/header/logo-header-mobile.svg'
import { Button } from '@/components/atoms/Button/Button'
import { LanguageSelector } from '@/components/molecules/LanguageSelector/LanguageSelector'
import { X } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

interface MenuMobileProps {
  closeModal: () => void
}

export function MenuMobile ({ closeModal }: MenuMobileProps): JSX.Element {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleScroll = (sectionId: string): void => {
    const section = document.getElementById(sectionId)
    if (section != null) {
      section.scrollIntoView({ behavior: 'smooth' })
    }
    closeModal()
  }

  return (
    <div className='fixed inset-0 z-50 bg-white p-6'>
      {/* Header del menú móvil */}
      <img src={logoHeaderFondo} alt='Synapses Group Logo Fondo' className='z-[-1] absolute top-0 left-[8rem] w-full' />
      <div className='flex justify-end items-center mb-8'>
        <button
          onClick={closeModal}
          className='p-2 rounded-full hover:bg-gray-100 transition-colors'
          aria-label='Close menu'
        >
          <X size={24} className='text-[#007EA1]' />
        </button>
      </div>
      <div className='flex justify-center items-center mb-8'>
        <img src={logoHeader} alt='Synapses Group Logo' />
        <button
          onClick={closeModal}
          className='p-2 rounded-full hover:bg-gray-100 transition-colors'
          aria-label='Close menu'
        />
      </div>

      {/* Opciones del menú */}
      <nav className='flex flex-col gap-8 px-6'>
        <button
          onClick={() => navigate('/')}
          className='text-left text-xl text-[#007EA1] hover:text-[#4DEEDB] transition-colors'
        >
          {t('header.home')}
        </button>

        <button
          onClick={() => navigate('/about')}
          className='text-left text-xl text-[#007EA1] hover:text-[#4DEEDB] transition-colors'
        >
          {t('header.about')}
        </button>

        <button
          onClick={() => navigate('/services')}
          className='text-left text-xl text-[#007EA1] hover:text-[#4DEEDB] transition-colors'
        >
          {t('header.services')}
        </button>
      </nav>

      {/* Botón de idioma y acción */}
      <div className='flex justify-center flex-col items-center gap-4 absolute bottom-8 left-6 right-6' onClick={() => handleScroll('formContactSynapses')}>
        <Button className='w-full text-[#4DEEDB]' size='sm'>
          {t('header.contact')}
        </Button>
        <LanguageSelector className='mb-4' />
      </div>
    </div>
  )
}
